
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/es5/locale/es'
//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { es },
        current: 'es'
    },
    theme: {
        themes: {
            light: {
                primary: "#6b0000",
                background: "#F6F8FE",
            },
            dark: {
                primary: "#9e0202",
                background: "#282828",
            }
        }
    }
});
